import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import withLanguage from "../HOC/withLanguage";

function SingleDualBlog({language}) {
    const { id } = useParams();
    const lang = useSelector((state) => state.language.currentLanguage);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        const ac = new AbortController();
        setLoading(true);
        setErr(null);

        // single endpoint + ?lang
        const url = `/api/dual_system/professional_dual_system/${id}?lang=${encodeURIComponent(
            lang || "al"
        )}`;

        fetch(url, { signal: ac.signal })
            .then(async (r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then((data) => {
                // backend might return {records:[{...}]} or single object; handle both
                const rec =
                    (Array.isArray(data?.records) ? data.records[0] : null) || data || null;
                setItem(rec);
            })
            .catch((e) => {
                if (e.name !== "AbortError") setErr(e.message || "Failed to load");
            })
            .finally(() => setLoading(false));

        return () => ac.abort();
    }, [id, lang]);

    if (loading) return <div className="p-6 text-center">Loading…</div>;
    if (err) return <div className="p-6 text-center text-red-600">Error: {err}</div>;
    if (!item) return <div className="p-6 text-center">Not found.</div>;

    const imgSrc = item?.image ? `data:image/jpeg;base64,${item.image}` : null;

    return (
        <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem] py-10">

            <h1 className="text-3xl font-bold mb-4">{item?.title || ""}</h1>

            {imgSrc && (
                <div className="w-full rounded-xl overflow-hidden shadow mb-6">
                    <img
                        src={imgSrc}
                        alt={item?.title || "Blog image"}
                        className="w-full h-auto object-cover"
                    />
                </div>
            )}

            <article className="prose max-w-none">
                <p className="whitespace-pre-wrap leading-7 text-[16px] text-gray-900">
                    {item?.description || ""}
                </p>
            </article>
        </div>
    );
}
export default withLanguage(SingleDualBlog, "PracticeDual");
